import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { buildFinancialApiUrl } from '../utils/financial-api-url.util';
import { Agreement, CreateAgreementPayload, MarkPaymentPaidPayload, PendingReceivable, AgreementPayment } from '../models/Agreement';

@Injectable({ providedIn: 'root' })
export class AgreementService {

  private financialUrl(path = ''): string {
    return buildFinancialApiUrl('agreements', path);
  }

  constructor(private http: HttpClient) {}

  getAll(filters?: { status?: string; customerId?: number; vehicleRentalId?: number }): Observable<Agreement[]> {
    let params = new HttpParams();
    if (filters?.status) params = params.set('status', filters.status);
    if (filters?.customerId) params = params.set('customerId', filters.customerId.toString());
    if (filters?.vehicleRentalId) params = params.set('vehicleRentalId', filters.vehicleRentalId.toString());
    return this.http.get<Agreement[]>(this.financialUrl(), { params });
  }

  getById(id: number): Observable<Agreement> {
    return this.http.get<Agreement>(this.financialUrl(`/${id}`));
  }

  getPendingReceivablesByCustomer(customerId: number): Observable<PendingReceivable[]> {
    return this.http.get<PendingReceivable[]>(this.financialUrl(`/pending-receivables/${customerId}`));
  }

  create(payload: CreateAgreementPayload): Observable<Agreement> {
    return this.http.post<Agreement>(this.financialUrl(), payload);
  }

  update(id: number, data: Partial<Agreement>): Observable<Agreement> {
    return this.http.put<Agreement>(this.financialUrl(`/${id}`), data);
  }

  cancel(id: number, cancelledBy: string): Observable<any> {
    return this.http.post(this.financialUrl(`/${id}/cancel`), { cancelledBy });
  }

  markPaymentAsPaid(paymentId: number, payload: MarkPaymentPaidPayload): Observable<AgreementPayment> {
    return this.http.post<AgreementPayment>(this.financialUrl(`/payments/${paymentId}/pay`), payload);
  }
}
